import { Form, Modal } from "antd"
import { useEffect, useMemo, useState } from "react"
import { csSkillsSet, itSkillsSet, softSkillsSet } from "../../Utils"
import { Filters } from "./Filters"
import { Trainings } from "./Trainings"
import { getFilters } from "./utils"

export const TrainingsBrowserModal = ( {
	rsSkillsGroup,
	trainings,
	open,
	initialSkillsGroup = [],
	onClose,
	showMessage,
	onTrainingsPick,
	skills,
} ) => {
	const filters = useMemo( () => getFilters( trainings ), [ trainings ] )

	const [ filter, setFilter ] = useState( () => ( {
		countries: [],
		languages: [],
		typeFormats: [],
		organizers: [],
		canLeadToCertifications: [],
		includesExamsForCertifications: [],
		contentTypes: [],
		duration: [ filters.durationMin, filters.durationMax ],
		price: [ filters.priceMin, filters.priceMax ],
		itSkillsGroup: ( initialSkillsGroup ?? [] ).filter( skillGr => itSkillsSet.includes( skillGr ) ),
		csSkillsGroup: ( initialSkillsGroup ?? [] ).filter( skillGr => csSkillsSet.includes( skillGr ) ),
		sfSkillsGroup: ( initialSkillsGroup ?? [] ).filter( skillGr => softSkillsSet.includes( skillGr ) ),
		showOutdated: false,
		showPicked: false,
		trainingFocus: [],
		disableSuggestions: false,
		maxSuggestions: 1,
		maxTrainingsPerSuggestion: 6,
	} ) )
	const [ form ] = Form.useForm()

	const [ checkedTrainings, setCheckedTrainings ] = useState( [] )

	useEffect( () => {
		if ( typeof initialSkillsGroup?.length === "number" ) {
			const newSkillGroup = {
				itSkillsGroup: initialSkillsGroup.filter( skillGr => itSkillsSet.includes( skillGr ) ),
				csSkillsGroup: initialSkillsGroup.filter( skillGr => csSkillsSet.includes( skillGr ) ),
				sfSkillsGroup: initialSkillsGroup.filter( skillGr => softSkillsSet.includes( skillGr ) ),
			}
			setFilter( oldFilter => ( { ...oldFilter, ...newSkillGroup } ) )
			form.setFieldsValue( newSkillGroup )
		}
		setCheckedTrainings( [] )
	}, [ initialSkillsGroup, form ] )

	return (
		<Modal
			getContainer={ false }
			centered
			open={ open }
			title={ "Trainings Browser" }
			width={ 950 }
			cancelText={ "Close" }
			okButtonProps={ { disabled: checkedTrainings.length === 0 } }
			className={ "trainings-browser-modal" }
			onCancel={ () => {
				form.resetFields()
				setCheckedTrainings( [] )
				onClose()
			} }
			okText={ "Pick" }
			onOk={ () => {
				if ( onTrainingsPick ) {
					onTrainingsPick( checkedTrainings )
				}
				setCheckedTrainings( [] )
				onClose()
			} }
		>
			<div className={ "trainings-browser" }>
				<div className={ "trainings-browser-filter" }>
					<Filters
						form={ form }
						rsSkillsGroup={ rsSkillsGroup }
						onChange={ setFilter }
						filters={ filters }
						initialValues={ filter }
					/>
				</div>
				<div className={ "trainings-browser-list" }>
					<Trainings
						skills={ skills }
						onCheckTraining={ training =>
							setCheckedTrainings( ( oldTrainings ) => {
								let isChecked = oldTrainings.findIndex( ( tr ) => tr.id === training.id ) !== -1
								if ( isChecked ) {
									return oldTrainings.filter( ( tr ) => tr.id !== training.id )
								}
								return [ ...oldTrainings, training ]
							} ) }
						checkedTrainings={ checkedTrainings }
						showMessage={ showMessage }
						filter={ filter }
						form={ form }
						rsSkillsGroup={ rsSkillsGroup }
						trainings={ trainings }
					/>
				</div>
			</div>
		</Modal>
	)
}
